// FutureLab
import { ChatListDataInterface } from '../components/chat/ChatListItemsMobile';
import { PinnedMessageItem } from '../components/chat/ChatListMenu';
import {
	ProgramQuestionInterface,
	SessionDetailFormInterface,
	SessionFeedbackAnswerInterface,
	SessionFeedbackFormInterface,
} from '../components/feedback/SessionFeedback';

/* 
 Action Types Interfaces
*/

// General Action Interface
interface ActionType<T extends string, P> {
	type: T;
	payload: P;
	[extraProperty: string]: unknown;
}

// Logged In User
export enum LoggedInUserActions {
	RESGISTER_USER = 'RESGISTER_USER',
	LOGIN_USER = 'LOGIN_USER',
	LOGOUT_USER = 'LOGOUT_USER',
}

export type UserAction =
	| ActionType<typeof LoggedInUserActions.LOGIN_USER, boolean>
	| ActionType<typeof LoggedInUserActions.LOGOUT_USER, boolean>
	| ActionType<typeof LoggedInUserActions.RESGISTER_USER, boolean>;

// Logged In User Details
export enum LoggedInUserDetails {
	LOGGED_IN_USER_DETAILS = 'LOGGED_IN_USER_DETAILS',
}
export type LoggedInUserDetailsActions = ActionType<typeof LoggedInUserDetails.LOGGED_IN_USER_DETAILS, object>;

// Chat List
export enum ChatList {
	CHAT_LIST = 'CHAT_LIST',
}
export type ChatListActions = ActionType<typeof ChatList.CHAT_LIST, ChatListDataInterface[] | []>;

// User List Profiles
export enum LoadUserProfilesDetailsTypes {
	LOAD_USERS_PROFILES_DETAILS = 'LOAD_USERS_PROFILES_DETAILS',
}

export type LoadUserProfilesDetailsActions = ActionType<
	typeof LoadUserProfilesDetailsTypes.LOAD_USERS_PROFILES_DETAILS,
	UserDetailsListItem[]
>;

// Pending approval chat messages
export enum PendingApprovalChatTypes {
	LOAD_PENDING_APPROVAL_CHAT = 'LOAD_PENDING_APPROVAL_CHAT',
	ADD_PENDING_APPROVAL_CHAT = 'ADD_PENDING_APPROVAL_CHAT',
	REMOVE_PENDING_APPROVAL_CHAT = 'REMOVE_PENDING_APPROVAL_CHAT',
}

export type PendingChatMessagesActions =
	| ActionType<typeof PendingApprovalChatTypes.LOAD_PENDING_APPROVAL_CHAT, ChatListDataInterface[]>
	| ActionType<typeof PendingApprovalChatTypes.ADD_PENDING_APPROVAL_CHAT, ChatListDataInterface[]>
	| ActionType<typeof PendingApprovalChatTypes.REMOVE_PENDING_APPROVAL_CHAT, ChatListDataInterface[]>;

// Pinned Messages
export enum PinnedMessagesTypes {
	LOAD_PIN_MESSAGES = 'LOAD_PIN_MESSAGES',
	ADD_PIN_MESSAGES = 'ADD_PIN_MESSAGES',
	REMOVE_PIN_MESSAGES = 'REMOVE_PIN_MESSAGES',
	REMOVE_ALL_CHAT_ROOM_PINNED_MESSAGES = 'REMOVE_ALL_CHAT_ROOM_PINNED_MESSAGES',
}

export type PinnedMessagesActions =
	| ActionType<typeof PinnedMessagesTypes.LOAD_PIN_MESSAGES, PinnedMessageItem[]>
	| ActionType<typeof PinnedMessagesTypes.ADD_PIN_MESSAGES, PinnedMessageItem[]>
	| ActionType<typeof PinnedMessagesTypes.REMOVE_PIN_MESSAGES, PinnedMessageItem[]>
	| ActionType<typeof PinnedMessagesTypes.REMOVE_ALL_CHAT_ROOM_PINNED_MESSAGES, PinnedMessageItem[]>;

export enum PushNotificationTypes {
	REGISTER_NOTIFICATION = 'REGISTER_NOTIFICATION',
	UNREGISTER_NOTIFICATION = 'UNREGISTER_NOTIFICATION',
}

export type PushNotificationActions =
	| ActionType<typeof PushNotificationTypes.REGISTER_NOTIFICATION, PushNotificationData>
	| ActionType<typeof PushNotificationTypes.UNREGISTER_NOTIFICATION, PushNotificationData>;
/* 
  General Interfaces
*/

export interface PushNotificationData {
	fcmToken: string;
	userId: number | null;
	isRegistered: boolean;
}

export interface UserDetailsListRole {
	programId: number;
	description: string;
}

export interface UserDetailsListInfo {
	jobTitle: string | null;
	company: string | null;
}

export interface UserDetailsListItem {
	id: number;
	firstname: string;
	lastname: string;
	profile_photo: string | null;
	userInfos: UserDetailsListInfo | null;
	userRoles: UserDetailsListRole[];
}

export interface loginInput {
	password?: string;
	email?: string;
	recaptcha_token?: string | null;
}

export interface SignUpInput {
	email?: string;
	password?: string;
	recaptcha_token?: string | null;
	become_a_mentor?: boolean;
	verifyPassword?: string;
}

export interface ProgramDetailsInterface {
	approved: boolean;
	avatarColour: string;
	banner: string;
	chatSettings: number;
	createdAt: string;
	dashboardAlert: boolean;
	deactivated: boolean;
	description: string;
	endDate: string;
	enterpriseId: number;
	id: number;
	name: string;
	pairingMethod: number;
	photo: string;
	privacySettings: number;
	programType: number;
	removedAt: string;
	reviewSettings: number;
	slug: string;
	startDate: Date;
	supportAdminId: number;
	supportEmail: string;
	target: number;
	targetAudience: string;
	updatedAt: string;
	whatsappNotification: boolean;
	programEnterprises: any;
}
